export default __webpack_public_path__ + "static/media/Sponsor-1.40dd043e.png";